import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseRealPriceItem.module.scss'

const cx = className.bind(style)

export type Props = {
  date: string
  floor: string
  price: string
}

const MyhouseRealPriceItem: React.FC<Props> = ({ date, floor, price }: Props) => {
  return (
    <li className={cx('myhouse_price_item')}>
      <span className={cx('myhouse_price_date')}>{date}</span>
      <span className={cx('myhouse_price_floor')}>{floor}</span>
      <strong className={cx('myhouse_price_value')}>{price}</strong>
    </li>
  )
}

export default MyhouseRealPriceItem
